import { formatCurrency } from 'components/Widget/shared/currency';
import { SUMMARY_COPY } from './constants';
import type { ApySavingsResult } from './types';

interface ApySavingsCalculatorSummaryProps {
  result: ApySavingsResult;
  periodLabel: string;
}

/** Announcement only: the results panel stays on screen, so repeating the total in view would duplicate it. */
export const ApySavingsCalculatorSummary = ({ result, periodLabel }: ApySavingsCalculatorSummaryProps) => (
  <p className="sr-only">{SUMMARY_COPY.total(formatCurrency(result.totalSavings), periodLabel)}</p>
);
